<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/brand/logo_amica.png" width="130" height="33" alt="CoreUI Logo">
        <img class="navbar-brand-minimized" src="img/brand/logo_amica.png" width="130" height="33" alt="CoreUI Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <div style="width: 600px; max-width: 60%; padding-top: 15px;" class="ml-auto">
        <b-form-group class="row">
          <b-form-select class="col-md-12" id="month" @change="changeImplementation()" v-model="activeImplementation" :options="this.$store.getters.getImplementationsList"></b-form-select>
        </b-form-group>
      </div>
      <b-navbar-nav class="d-md-down-none">
         
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <TheFooter>
      <!--footer-->
      <div class="ml-auto" style="font-size: 10px;">
        <span class="mr-1">Powered by</span>
        <a href="https://coreui.io">CoreUI for Vue</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'

export default {
  name: 'full',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav: nav.items,
      activeImplementation: this.$store.getters.getActiveImplementation
    }
  },
  mounted () {
    if (!this.$store.getters.isUserLoggedIn) {
      this.$router.push('/login')
    }
  },
  methods: {
    changeImplementation: function () {
      let cmp = this
      cmp.$nextTick()
        .then(function () {
          cmp.$store.dispatch('changeCurrentImplementation', cmp.activeImplementation)
          cmp.$router.go(cmp.$route.fullPath)
        })
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>
